import { combineReducers } from 'redux';
import { penderReducer } from 'redux-pender';
import { encryptPersistReducer } from 'app/libs/encryptPersistReducer';
import auth from './auth';
import carInfo from './carInfo';
import address from './address';
import tooltip from './tooltip';
import model from './model';
import ryvuss from './ryvuss';
import saleCar from './saleCar';
import company from './company';
import page from './page';
import estimate from './estimate';
import cars from './cars';
import encarcenter from './encarcenter';
import hsContracts from './hsContracts';
import estimatePictureUpload from './estimatePictureUpload';
import auction from './auction';
import buyInquiry from './buyInquiry';
import carInfoSelect from './carInfoSelect';
import board from './board';
import ohMyCall from './ohMyCall';
import abTestV2 from './abTestV2';
// 홈서비스
import homeservice from './homeservice';
// 엔카페이
import encarpay from './encarpay';
// 중고차론
import loan from './loan';
// 안전거래
import escrow from './escrow';

// 차량검수
import carVerification from './carVerification';
// 에스크로 v2
import escrowV2 from './escrow-v2';
// 믿고
import meetgo from './meetgo';
// 전자계약서 모듈
import contracts from './contracts';

// 주문
import orders from './orders';

// 미리배송
import preDelivery from './pre-delivery';

// 회원가입
import join from './join';

export default combineReducers({
	pender: penderReducer,
	homeservice,
	encarpay,
	loan,
	auth,
	carInfo,
	address,
	tooltip,
	model,
	ryvuss,
	saleCar,
	company,
	page,
	estimate: encryptPersistReducer(
		{
			key: 'estimate',
			whitelist: ['proApplyInfo', 'applyCommon', 'proDeliveryInfo'],
		},
		estimate,
	),
	cars,
	encarcenter,
	hsContracts,
	estimatePictureUpload,
	auction,
	buyInquiry,
	carInfoSelect,
	board,
	ohMyCall,
	escrow,
	carVerification,
	escrowV2,
	meetgo,
	contracts,
	orders,
	preDelivery,
	join,
	abTestV2,
});
